export default "__VITE_ASSET__DyuaQPGw__"